import { defaultLocaleOptions } from 'constants/defaultValues';
import { getCurrentLanguage } from 'helpers/Utils';
import { CHANGE_LOCALE, SET_LOCALE_OPTIONS } from './constants';

const INIT_STATE = {
  locale: getCurrentLanguage(),
  localeOptions: defaultLocaleOptions,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };
    case SET_LOCALE_OPTIONS: {
      return {
        ...state,
        localeOptions: action.payload,
      };
    }
    default:
      return { ...state };
  }
};
